import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchAllOrdersForLab, payload);
    const { data } = res;
    yield put(actions.fetchOrdersSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrdersFailure(err?.response?.data));
  }
}

export function* handleFetchOrderCounts({ payload }) {
  try {
    const res = yield call(API.fetchOrderCounts, payload);
    const { data } = res;
    yield put(actions.fetchOrderCountsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderCountsFailure(err?.response?.data));
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleRejectOrder({ payload }) {
  try {
    const res = yield call(API.rejectOrder, payload);
    const { data } = res;
    yield put(actions.rejectOrderSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.rejectOrderFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUpdateOrderStatus({ payload }) {
  try {
    // if (payload.data.labSampleReceivedDetails) {
    //   console.log(payload.data.labSampleReceivedDetails);
    //   yield call(API.updateOrderStatus, payload.data.labSampleReceivedDetails);
    // }
    // delete payload.data.labSampleReceivedDetails;

    const res = yield call(API.updateOrderStatus, payload);
    const { data } = res;
    if (payload?.saveLabSampleResponse) {
    }
    if (res.data.status === "error") {
      yield put(actions.updateOrderStatusFailure(data));
    } else {
      yield put(actions.updateOrderStatusSuccess(data));
    }
    payload?.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateOrderStatusFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateOrderStatusFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUploadReport({ payload }) {
  try {
    console.log("Upload Report Payload: ", payload);
    // upload file
    const res = yield call(API.getFileUrl, {
      //fileName: payload.file.name,
      //source: payload.source,
      //fileUsedFor: payload.fileUsedFor,
      //companyId: payload.companyId,
      //orderId: payload.orderId,
      blobName: payload.file.name,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const url = res.data?.data?.document;
    const formData = new FormData();
    formData.append("file", payload.file);
    const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
    if (fileUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }
    // update order
    //const fileUploadedUrl = new URL(url);
    //const pathName = fileUploadedUrl?.pathname.slice(1);
    const updatePayload = {
      data: {
        //reportFile: pathName,
        // status: payload.status,
        reportFile: payload.file.name,
      },
      id: payload.id,
    };
    if (payload.status) {
      updatePayload.data.status = payload.status;
    }
    const updateRes = yield call(API.updateOrder, updatePayload);
    yield put(actions.uploadReportSuccess(updateRes.data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.uploadReportFailure({ id: payload.id, err }));
    payload.onFailure();
  }
}

export function* handleDownloadReport({ payload }) {
  try {
    console.log("Download Report Payload: ", payload);
    //const res = yield call(API.getDownloadUrl, payload);
    const { fileName } = payload.data;
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const link = document.createElement("a");
    link.href = data.data.document;
    link.setAttribute("download", payload.fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadFileSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadFileFailure({ id: payload.id, err }));
  }
}

export function* handleAllCommodities() {
  try {
    const res = yield call(API.fetchAllCommodities);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* orderListingSaga() {
  yield takeLatest(actions.fetchOrders.type, handleFetchOrders);
  yield takeLatest(actions.fetchOrderCounts.type, handleFetchOrderCounts);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeEvery(actions.updateOrderStatus.type, handleUpdateOrderStatus);
  yield takeEvery(actions.uploadReport.type, handleUploadReport);
  yield takeEvery(actions.downloadFile.type, handleDownloadReport);
  yield takeLatest(actions.rejectOrder.type, handleRejectOrder);
  yield takeLatest(actions.fetchCommodities.type, handleAllCommodities);
}
